import { render, staticRenderFns } from "./FailuresList.vue?vue&type=template&id=2cb9e315&scoped=true&"
import script from "./FailuresList.vue?vue&type=script&lang=js&"
export * from "./FailuresList.vue?vue&type=script&lang=js&"
import style0 from "./FailuresList.vue?vue&type=style&index=0&id=2cb9e315&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb9e315",
  null
  
)

export default component.exports